module.exports = __webpack_public_path__ + "f5d252d0b9d1c720ddf7be353b73f178.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-female-1.svg
// module id = 82
// module chunks = 0